export default __webpack_public_path__ + "static/media/goalIcon.84d24228.svg";